<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">第五届Light创造营启动！提供全方位技术支持，助力公益可持续创新</div>
      <div class="news-date">2025年3月3日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <p>3月3日，第五届Light创造营在厦门正式拉开帷幕。本届Light号召高校学子利用AI技术打造多元技术公益解决方案，共同应对社会公共议题，持续释放技术公益的内在价值。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news76.webp"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">本届Light在公益议题设置上更为开放，</span>
          倡导满足联合国可持续发展目标方向，参与者无需提交已落地项目即可报名；同时，
          <span class="mark-text highlight">通过不断升级的技术工具箱，</span>
          大幅降低了公益项目的参与门槛，为技术与公益的深度融合提供了坚实支撑。
        </p>
        <p>
          另外，为加速优秀项目的成果转化，本届创造营特别引入腾讯可持续社会价值事业部（腾讯SSV）的深度参与。通过"技术+场景+生态"的立体化培育机制，
          <span class="mark-text highlight">入围项目将有机会纳入腾讯SSV创新孵化体系，获得从产品打磨到试点落地的一站式支持。</span>
        </p>
        <p>腾讯云副总裁、腾讯云智能及优图实验室负责人吴运声在启动仪式上表示：“一名开发者可以用代码守护濒危物种、一支学生团队能用动画帮助特殊儿童、一家企业可以开放技术和资源鼓励更多领域的人士参与公益事业。我们希望通过Light平台，让更多人能轻松运用技术，共同解决社会公共议题。”</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news76/news76_1.webp"/>
            <span>腾讯云副总裁、腾讯云智能及优图实验室负责人 吴运声</span>
          </div>
        </div>
        <p>腾讯公益慈善基金会秘书长葛燄也认为：“AI大模型等前沿科技在公益领域蕴藏无限可能，同时也能激发青年在推动社会变革中的关键作用。面对这波技术浪潮，只有以开放与务实的态度，将AI技术转化为切实的公益力量，才能构建一个充满希望与活力的未来。”</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news76/news76_2.webp"/>
            <span>腾讯公益慈善基金会秘书长 葛燄</span>
          </div>
        </div>
        <p>藉由此，在关注技术创新的同时，本届创造营还融入了对AI在社会层面潜在影响的探讨。关注 AI技术在社区、生态、教育、文化、“一老一小”与特殊群体帮扶等方面的挑战与机会，旨在促使开发者和学生在追求技术突破的同时，培养负责任的科技观，实现科技进步与社会公平的平衡。</p>
        <p>第五届Light创造营由腾讯公益慈善基金会、厦门大学教育发展基金会主办，腾讯SSV、厦门大学人工智能研究院、腾讯优图实验室、腾讯云智能联合承办。厦门大学副校长、厦门大学教育发展基金会副理事长邱伟杰，厦门大学科技处处长、人工智能研究院负责人纪荣嵘，厦门大学教育发展基金会秘书长赵晓慧，共青团厦门大学委员会书记张晴，上海真爱梦想公益基金会副秘书长夏腾飞，益优青年服务中心创始人兼副理事长任敏，腾讯公益慈善基金会秘书长葛燄，腾讯云副总裁、腾讯云智能负责人、腾讯优图实验室负责人吴运声等嘉宾出席了本次活动。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news76/news76_3.webp"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>科技助力公益创新 公益种子不断生根发芽</div>
        </div>
        <p>
          <span class="mark-text highlight">历经五年发展与沉淀，Light·创造营已经吸引了4679支队伍、超过万名开发者参与，成为国内最具影响力的技术公益实践平台之一。</span>
          从野生动植物保护、空巢老人关怀，到山区教育及老年人网络安全，平台不断探索技术与公益的深度融合，为技术公益的长远发展注入新活力。
        </p>
        <p>
          厦门大学副校长、厦门大学教育发展基金会副理事长邱伟杰在致辞中高度肯定了Light平台的初心与价值，并呼吁更多高校学生和青年力量积极关注并参与这一公益实践。他指出，
          <span class="mark-text highlight">腾讯发起的Light技术公益创造营通过技术赋能公益，推动社会问题的解决和公益事业的进步，不仅促进了跨界合作和资源共享，还提升了公益组织的能力建设，产生了广泛的社会影响和示范效应，其注重可持续发展和长期价值的理念，展现了科技向善的力量，确保了技术公益项目的持续性和有效性，为未来的公益事业提供了新的思路和方向。</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news76/news76_4.webp"/>
            <span>厦门大学副校长、厦门大学教育发展基金会副理事长 邱伟杰</span>
          </div>
        </div>
        <p>以科技延伸公益价值，一直是腾讯所坚持的方向。在腾讯基金会的倡导下，Light·创造营等计划已孕育出一批可持续发展的优秀项目。</p>
        <p>
          其中，由中国传媒大学动画与数字艺术学院教授范敏领衔的团队开发的基于AI的儿童情绪学习系统，
          <span class="mark-text highlight">通过动画互动与表情识别反馈，帮助自闭症（ASD）儿童理解社交场景、学习情绪表达。</span>
        </p>
        <p>该系统依托腾讯云AI接口实现实时情绪分析，已在北京、浙江、山西、贵州等10余家机构推广，累计服务超过500名儿童，干预成本降低60%，并荣获2024年Light技术公益创造营年度公益创新项目奖，成为腾讯云AI公益生态的标杆案例。</p>
        <p>另一典型案例由2002年出生的年轻CEO招志锐领军。他凭借华南农业大学植物保护专业背景创立广州市农潮科技服务有限公司，推出“绿美阅行”数字化自然教育平台，将城市公园改造为沉浸式自然课堂。</p>
        <p>基于“公园20分钟效应”的研究成果，团队开发了微信小程序，通过AI数字人交互及剧本任务，引导用户探索公园动植物，解锁图鉴并兑换濒危物种文创周边，同时整合腾讯大模型等前沿能力，实现20万种生物的AI识别。该项目已覆盖广深等城市400余所学校，举办活动630场，累计访问人数达40万，联动政府、景区和科研单位构建起“自然教育+生态保护”的闭环。</p>
        <div class="news-content-mark">
          <div>创议题拓宽、技术工具升级 助力开启社会“共益时代”</div>
        </div>
        <p>针对当下社会发展中所面临的部分共性问题，第五届Light创造营在议题设置上全新升级，以更大自由度的方案提报，助力更广泛社会问题的有效解决。</p>
        <p>
          <span class="mark-text highlight">首先，拓宽议题范围，迈向共益新时代。</span>
          本届活动主题全面开放，不设固定议题方向，参与者无需提交已实际落地项目，只要拥有富有创意的技术公益想法，即可报名参与。鼓励团队跨领域探索，将前沿技术与公益理念深度融合，共同推动技术在社会共益领域的创新应用，开创共享共益的新未来。
        </p>
        <p>
          <span class="mark-text highlight">其次，技术工具箱持续升级，助力公益低门槛落地。</span>
          腾讯为创造营参与者提供全方位的技术支持，涵盖 AI、音视频、智能客服、数字人等多个前沿领域。比如，基于腾讯云大模型知识引擎，可以帮助开发者实现免部署、分钟级搭建AI应用。这些技术能力让公益创新更加高效、便捷。
        </p>
        <p>目前，Light·创造营已开放 300+ AI原子能力，这些能力在工业、金融、传媒等多个领域已实现成熟、稳定、安全、合规的技术落地，并经过市场的考验。不断升级的技术工具箱，正助力公益项目突破技术壁垒，加速落地实践。</p>
        <p>
          同时，为加速优秀项目的成果转化，本届创造营特别联合腾讯可持续社会价值事业部（腾讯SSV）深度参与。腾讯SSV将全程关注参与团队的技术公益实践，对具有社会创新价值的AI for Good方案进行专项辅导。
          <span class="mark-text highlight">通过"技术+场景+生态"的立体化培育机制，入围项目将有机会纳入腾讯SSV创新孵化体系，获得从产品打磨到试点落地的一站式支持，让创意真正转化为可持续的社会价值解决方案。</span>
        </p>
        <p>基于前几届的实践经验，本届创造营已初步探索出一条健康可持续的技术公益发展路径：技术层面，用AI提升公益效率，降低运营成本；产品层面，依托多元资源，加速公益项目落地，扩大覆盖面与推广性；运营层面，充分连接政府、公益机构及开发者之间的需求与资源，以技术公益平台为纽带，开启解决社会问题的“共益时代”。</p>
        <div class="news-content-mark">
          <div>坚守科技向善愿景 Light践行科技公益战略</div>
        </div>
        <p>自2021年4月宣布“可持续社会价值创新”战略升级以来，腾讯始终秉持“科技向善”的核心理念，不断拓展科技与公益的边界。</p>
        <p>在发布会现场，腾讯公益慈善基金会秘书长葛燄与多位业界嘉宾围绕「‘青年力量+AI’为公益助燃」主题展开深入探讨，共同探寻AI技术如何为公益注入新动能，并为当下的青年群体呈现出AI+公益的真实图景，鼓励他们用科技创造力为社会绘就更加美好的画卷。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news76/news76_5.webp"/>
          </div>
        </div>
        <p>葛燄表示，随着AI技术门槛的不断降低，公益组织应积极拥抱技术，借助成熟的AI产品提升公益服务效率。数字公益的发展需要更加紧密的生态合作，只有将AI深度融入社会需求，才能让科技发挥最大价值，为公益事业带来真正的变革。</p>
        <p>厦门大学科技处处长、人工智能研究院负责人纪荣嵘指出，AI的发展正突破传统“数据+算力”的模式，DeepSeek等新技术正显著降低算力和数据需求，使人工智能的普及变得更低成本、更高效。AI的变革不仅重塑技术本身，还深刻影响着教育、职场及产业结构，不主动拥抱AI的个人与城市，都将面临被时代淘汰的风险。</p>
        <p>上海真爱梦想公益基金会副秘书长夏腾飞谈到，AI技术的发展速度超乎想象，从最初的助手迅速成长为“老师”，这种转变令人既兴奋又迷茫。面对变革，青年人应主动拥抱AI，将其作为学习和成长的契机，而非被技术洪流裹挟。</p>
        <p>上海益优青年服务中心创始人兼副理事长任敏表示，AI的普及正在大幅降低教育成本，使个性化教育与素质教育的普惠成为可能，让更多孩子能够享受到优质的教育资源。同时，AI在公益领域的应用前景广阔，不仅能帮助老年人记录人生故事，还能提升公益组织的运营效率，让公益服务更加精准、高效。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news76/news76_6.webp"/>
          </div>
        </div>
        <p>
          未来，腾讯将持续连接社会公益力量，探索技术与公益的创新结合。第五届Light·技术公益创造营将于
          <span class="mark-text highlight">4月20号</span>
          结束征集，届时来自内地高校的优秀技术公益案例将陆续亮相，共同开启社会共益的崭新篇章。
        </p>
        <p>
          <span class="mark-text highlight">更多活动详情可以关注「腾讯Light计划」官方公众号</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News76.vue